import _ from "lodash";
import React from "react";
import { NavLink, useNavigate, useOutletContext } from "react-router-dom";
import styled from "styled-components";
import withRouter from "../../services/HOC/withRouterHOC";
import { useState } from "react";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import apiPaths from "../../services/apPaths";

const FooterCss = styled.div`
  z-index: 10;
  position: relative;
  background: linear-gradient(90deg, rgba(2, 55, 109, 1) 0%, rgba(94, 136, 236, 1) 50%, rgba(209, 137, 168, 1) 125%);
  font-family: var(--common-font);

  /* padding: 59px 0 80px; */
  padding: 50px 0 0px;

  @media only screen and (max-width: 1199px) {
    padding: 50px 0 0px;
  }

  @media only screen and (max-width: 767px) {
    padding: 20px 0 0;
  }
ul{
  cursor: pointer;
}
li a{
  color: #fff;
}
  figure img {
    height: 100%;
    width: 100%;
    object-fit: contain;
    display: block;
    max-width: 200px;
}
  .footer-listing {
    display: flex;
    justify-content: space-between;
    color: #fff;
  }
  p.disclaimer {
    color: #06356a !important;
    font-size: 12px;
    font-family: "Graphik";
    font-weight: 500;
  }
 .trademark{
    display: flex;
    justify-content: space-evenly;
    color: #000;
    width: 100%;
    height: 100%;
    margin-top: 50px;
    padding: 20px;
    font-size: 14px;
    @media (max-width:1199px){
      padding: 10px 0px;
    }
 }
 .policies {
    display: flex;
    gap: 26px;
    @media (max-width:540px){
      flex-wrap: wrap;
      gap: 10px;
    }
}
.policies a {
    color: #000;
    font-size: 14px;
    position: relative;
    &:not(:last-child):after{
      content: "";
      width: 1px;
      height: 12px;
      background: #8d8b8b;
      position: absolute;
      right: -13px;
      top: 4px;
      @media (max-width:540px){
        display: none;
      }
    }
    @media (max-width:540px){
      width: 100%;
      text-align: center;
    }
}

.footer-wrap {
    display: flex;
    align-items: flex-start;
    column-gap: 200px;
    @media (max-width:1199px){
      column-gap: 50px;
    }
    @media (max-width:991px){
      flex-wrap: wrap;
      justify-content: center;
      gap: 30px;
    }
    }


.footer-wrap .footer-listing {
    margin-left: auto;
    display: flex;
    width: 100%;
    gap: 20px;
    @media (max-width:991px){
      flex-wrap: wrap;
      justify-content: center;
      gap: 20px;
    }
    &>div{
      @media (max-width:991px){
      width: 100%;
      text-align: center;
    }
    }
    .mobile{
      display: none;
      @media (max-width:991px){
        display: block;
      }
    }

}

.footer-wrap .footer-listing>div>div {
    font-size: 21px;
    font-weight: 700;
    line-height: 1.1;
    margin-bottom: 12px;
    @media (max-width:991px){
      margin-bottom: 8px;
    }
}
.footer-wrap .footer-listing>div ul li:not(:last-child) {
    margin-bottom: 10px;
    @media (max-width:991px){
      margin-bottom: 0px;
    }
}
.footer-wrap figure {
    margin-bottom: 0;
}
.footer-wrap figure img {
    max-width: 250px;
}
.trademark {
  background-color: #c3cfde;
  text-align:center;
}
.footer-wrap .footer-listing>div ul li {
    font-size: 20px;
    @media (min-width:1199px){
      font-size: 18px;
    }
}
.site-footer-main {
    @media (min-width:1400px){
      max-width: 1500px;
    }
 
}
.trademark .container {
    // display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    .resgistered-trade{
      @media (max-width:767px){
        text-align: center;
      }
    }
    @media (max-width:1399px){
      flex-wrap: wrap;
      justify-content: center;
      gap: 10px;
    }
}
.footer-wrap .cards-section {
    display: flex;
    margin-top: 24px;
    flex-wrap: wrap;
    gap: 10px;
    @media (max-width:991px){
      margin-top: 30px;
    }
    &.desktop{
    @media (max-width:991px){
      display: none;
    }
    }
}
.footer-wrap .cards-section img {
    width: calc(100% / 4 - 8px);
    max-width: 100% !important;
    display: flex;
}
    .footer-wrap ul.footer-menu li.haschildern {
    position: relative;
}

.footer-wrap ul.footer-menu li.haschildern ul.submenu {
    height: 0;
    transition: all 0.2s ease-in-out;
    clip-path: polygon(0 0, 100% 0, 100% 0, 0 0);
    margin-top: 10px;
  }

.footer-wrap ul.footer-menu li.haschildern.haschildern-open ul.submenu {
    background: #fff;
    color: #000;
    height: auto;
    padding: 4px 15px;
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
}
.footer-wrap  li.haschildern svg {
    position: relative;
    top: -1px;
    transition: all 0.2s ease-in-out;
}
 
 .footer-wrap li.haschildern.haschildern-open svg {
    transform: rotate(180deg);
}
   .footer-wrap ul.footer-menu ul.submenu a, .footer-wrap ul.footer-menu ul.submenu li {
    font-size: 16px !important;
}
.footer-text{
    max-width: 980px;
    background: #fff;
    padding: 20px 30px;
    margin: 25px auto 30px;
    font-size: 13px;
    font-weight: 600;
    color: #06356a !important;
    box-shadow: 0 0 0 6px rgb(255, 255, 255);
    position: relative;
    overflow: hidden;
    height: auto;   
}
.footer-text::before {
    content: "O";
    position: absolute;
    font-size: 90px;
    font-family: 'FontAwesome';
    opacity: 9%;
    left: -44px;
    right: auto;
    top: -60px;
}
.footer-listing ul.footer-menu li.haschildern {
    position: relative;
}

.footer-listing ul.footer-menu li.haschildern ul.submenu {
    position: absolute;
    top: 20px;
    left: 0;
    min-width: max-content;
    z-index: 10;
}
.main-disclaimer-section {
    max-width: 1078px;
    margin-right: 0;
    margin-left: auto;
}

.main-disclaimer-section .footer-text {
    width: 100%;
}
`;
const Footer = ({ showloader, isLoginToken, innerLoader, subDomain, ...props }) => {
  const navigate = useNavigate();
  const [isSubmenuOpen, setSubmenuOpen] = useState(false);

  const toggleSubmenu = () => {
    setSubmenuOpen(!isSubmenuOpen);
  };
  return (
    <FooterCss>
      <div className="container site-footer-main">
        <div className="footer-wrap">
          <figure>
            <a onClick={() => navigate("/")}>
              <img src="/images/New-logo.png" alt="fOOterLogO" />
            </a>
            <div className="cards-section desktop">
              <img src="/images/visacard.png" alt="cards-logo" />
              <img src="/images/master.png" alt="cards-logo" />
              <img src="/images/american.png" alt="cards-logo" />
              <img src="/images/discover.png" alt="cards-logo" />
            </div>
          </figure>
          <div class="footer-listing">
            <div className="support-section">
              <div>Support</div>
              <ul className="footer-menu">
                <li onClick={() => navigate("/faq")}>FAQ's</li>
                <li className={isSubmenuOpen ? "haschildern haschildern-open" : "haschildern"}>

                  <div onClick={(e) => toggleSubmenu()}> Contact Us <ArrowDropDownIcon /> </div>

                  {/* {!isSubmenuOpen && ( */}
                  <ul className="submenu">
                    <li >
                      <a style={{ color: "#000" }} href="mailto:support@kaire.com">Email: support@kaire.com</a>
                    </li>
                    <li>Phone (USA & Canada): 1-877-603-1710</li>
                    <li>Phone (New Zealand): 0800-451353</li>
                    <li>Phone (Australia): 1-800-737-643</li>
                  </ul>
                  {/* )} */}
                </li>
                <li onClick={() => navigate("/accessibility")}>Accessibility</li>
              </ul>
            </div>
            <div className="about-section">
              <div>About</div>
              <ul>
                <li onClick={() => navigate("/ourstory")}>Our Company</li>
                {/* <li onClick={() => navigate("/signup")}>Affiliate</li> */}
              </ul>
            </div>
            <div className="account-section">
              <div>Account</div>
              <ul>
                <li onClick={() => navigate("/login")}>Login</li>
                <li onClick={() => navigate("/signup")}>Sign Up</li>
              </ul>
            </div>
            <div className="phone-section">
              <div>Policies</div>
              <ul>
                <li onClick={() => window?.open("/pdf/Kaire-Return-refund-policy.pdf")}>Refund and Return Policy</li>
                <li onClick={() => window?.open("/pdf/Kaire-Terms&conditions-1.pdf")} >Terms & Conditions</li>
                <li onClick={() => window?.open("/pdf/Kaire-privacy-policy.pdf")} >Privacy Policy</li>
              </ul>
            </div>

            <figure className="mobile">

              <div className="cards-section">
                <img src="/images/visacard.png" alt="cards-logo" />
                <img src="/images/master.png" alt="cards-logo" />
                <img src="/images/american.png" alt="cards-logo" />
                <img src="/images/discover.png" alt="cards-logo" />
              </div>
            </figure>

          </div>
        </div>
        <div className="main-disclaimer-section">
          <div className="footer-text">
            <p className="disclaimer">
              These statements have not been evaluated by the Food and Drug Administration. These products are not intended to diagnose, treat, cure or prevent
              any disease. Use only as directed. The information provided in this page is intended for your general knowledge and
              information purposes only and is not a substitute for a medical advice or treatment for specific medical conditions.
              Consult with your doctor or a medical professional and follow safety instructions before beginning an exercise program or
              using a Dietary Supplement if you are undergoing treatment or on medication or have a medical condition.
            </p>
          </div>

        </div>
      </div>
      <div className="trademark">
        <div className="container">
          <div className="resgistered-trade">
            © 2025 eKaire.com, Inc. All Rights Reserved. Kaire ™ is a registered trademark of eKaire.com, Inc.
          </div>
          {/* <div className="policies">
            <a
              className="privacy_style"
              target="_blank"
              href="https://commandconcept.csdevhub.com/media/pdf_files/INCOME_DISCLOSURE.pdf"
            >
              Income Disclaimer
            </a>
          </div> */}
        </div>
      </div>
    </FooterCss >

  );
};

export default Footer;
